/* eslint-disable jsx-a11y/label-has-for,react/no-did-mount-set-state */
import React, { Component } from 'react';
import {
  CustomInput,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';


class Filter extends Component {
  /**
   * This method analyzes url's search params and extracts the sort and data-xxx params
   * Then returns an object with sort and dataFilters properties
   */
  static extractUrlParams() {
    const otherParams = [];
    const dataFilters = _.chain(window.location.search)
      .replace('?', '')
      .split('&')
      .map(_.ary(_.partial(_.split, _, '='), 1))
      .value()
      .filter(([key, value]) => {
        if (key.length) {
          if (key.startsWith('data-')) {
            return true;
          }
          if (key !== 'filterDisplayed') {
            otherParams.push(`${key}=${value}`);
          }
        }
        return false;
      })
      .map(([key, value]) => ({ key, value }));

    return {
      dataFilters,
      otherParams,
    };
  }

  constructor(props) {
    super(props);
    this.onFilterCheckboxChange = this.onFilterCheckboxChange.bind(this);
    this.onFilterValueChange = this.onFilterValueChange.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.state = { formFields: [] };
  }

  componentDidMount() {
    const { dataFilters, otherParams } = Filter.extractUrlParams();
    const parsedFilters = this.props.formFields.map((filter, index) => {
      // find if we have item in url params
      const filterInUrl = _.find(dataFilters, item => item.key === `data-${filter.name}`);
      return {
        name: filter.name,
        active: filterInUrl !== undefined,
        value: filterInUrl !== undefined && filterInUrl.value === 'true',
        key: index,
      };
    });

    this.setState({ formFields: parsedFilters, otherParams });
  }

  /**
   * This is executed when checking/unchecking the checkbox for a filter
   * @param changedFilter
   */
  onFilterCheckboxChange(changedFilter) {
    const updatedFilters = this.state.formFields.map((filter) => {
      if (filter.key === changedFilter.key) {
        return {
          ...changedFilter,
          active: !filter.active,
          value: true,
        };
      }
      return filter;
    });
    this.setState({ formFields: updatedFilters }, () => {
      this.applyFilter();
    });
  }

  /**
   * This is executed when changing the value for a filter with the dropdown
   * @param changedFilter
   */
  onFilterValueChange(changedFilter) {
    const updatedFilters = this.state.formFields.map((filter) => {
      if (filter.key === changedFilter.key) {
        return {
          ...changedFilter,
          value: !filter.value,
        };
      }
      return filter;
    });
    this.setState({ formFields: updatedFilters }, () => {
      this.applyFilter();
    });
  }

  applyFilter() {
    const filtersURL = this.state.formFields
      .filter(filter => filter.active === true)
      .map(filter => `data-${filter.name}=${filter.value}`);

    let updatedURL = '';
    if (this.state.otherParams.length) {
      updatedURL = this.state.otherParams.join('&');
    }
    if (updatedURL.length) {
      updatedURL = `${updatedURL}&`;
    }
    if (filtersURL.length) {
      updatedURL = `${updatedURL}${filtersURL.join('&')}`;
    }
    if (this.props.show) {
      updatedURL = `${updatedURL}&filterDisplayed=true`;
    }
    window.location.search = updatedURL;
  }

  renderFilterElements(filter) {
    return (
      <div className="filter-item" key={filter.key}>
        <CustomInput
          type="checkbox"
          id={`checkbox-${filter.name}`}
          label={filter.name}
          checked={filter.active}
          onChange={() => this.onFilterCheckboxChange(filter)}
        />
        <UncontrolledDropdown>
          <DropdownToggle
            color="primary"
            outline
            size="sm"
            caret
            disabled={!filter.active}
            style={{ width: '100%' }}
          >
            {filter.value.toString()}
          </DropdownToggle>
          <DropdownMenu>
            {[true, false].map(v => (
              <DropdownItem
                key={`select-${filter.name}-${v}`}
                active={filter.value === v}
                onClick={() => this.onFilterValueChange(filter)}
              >
                {v.toString()}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    );
  }

  render() {
    if (!this.state.formFields.length) {
      return <span />;
    }
    return (
      <div className={`filter-container ${this.props.show ? 'show' : ''}`}>
        <div
          className="filter-body"
          id="gallery-filter-body"
        >
          { this.state.formFields.map(filter => this.renderFilterElements(filter)) }
        </div>
      </div>
    );
  }
}

Filter.propTypes = {
  formFields: PropTypes.array,
  show: PropTypes.oneOfType([
    PropTypes.bool, PropTypes.string,
  ]),
};

Filter.defaultProps = {
  formFields: [],
  show: false,
};

export default Filter;



// WEBPACK FOOTER //
// ./src/client/components/common/Filter.js